// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".legend-keys-inline {\n  display: flex;\n}\n\n.legend-keys-inline > .legend-key:not(:first-child) {\n  margin-left: 12px;\n}\n", "",{"version":3,"sources":["webpack://src/views/LegendKeysInline.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB","sourcesContent":[".legend-keys-inline {\n  display: flex;\n}\n\n.legend-keys-inline > .legend-key:not(:first-child) {\n  margin-left: 12px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
